<template>
  <div id="contenedor-obras-picker">
    <v-autocomplete
      v-model="obrasSeleccionadas"
      :label="getLabel"
      :items="getObras"
      return-object
      :multiple="multiSelect"
      filled
      clearable
      color="#6A83B5"
      background-color="#F2F6FF"
      item-text="clave"
      :filter="filtro"
      :search-input.sync="search"
      @change="enviarSeleccionados">
      <template
        v-slot:item="data">
        <v-list-item-avatar>
          <v-avatar
            size="24"
            :color="data.item.tipo.color">
          </v-avatar>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title>
            {{ data.item.clave }}
          </v-list-item-title>
          <v-list-item-subtitle>
            {{ data.item.meta.slice(0,35) }}...
          </v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </v-autocomplete>
  </div>
</template>

<script>
import OBRAS_SOLICITUDES from '@/graphql/querys/administracion/obrassolicitudes/obrasSolicitudes.gql';
import mixFormatoEstructura from '@/helpers/mixFormatoEstructura';

export default {
  name: 'ObrasPicker',
  data() {
    return {
      obrasSeleccionadas: [],
      search: '',
    };
  },
  props: {
    /*
    obrasContratos: {
      type: Array,
      required: false,
      default() {
        return [];
      },
    }, */
    multiSelect: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  mixins: [mixFormatoEstructura],
  methods: {
    filtro(item, queryText) {
      const clave = item.clave.toLowerCase();
      const meta = item.meta.toLowerCase();

      const expt = new RegExp(queryText, 'gi');

      return expt.test(clave) || expt.test(meta);
    },
    enviarSeleccionados() {
      // V-MODEL
      this.$emit('input', this.obrasSeleccionadas);
      // ENVIAR SOLO IDS SELECCIONADOS
      if (this.multiSelect === true) {
        this.$emit('solo-ids', this.obrasSeleccionadas.map((obra) => obra.id));
      } else if (this.obrasSeleccionadas !== null) {
        this.$emit('solo-ids', [this.obrasSeleccionadas.id]);
      } else {
        this.$emit('solo-ids', []);
      }
    },
  },
  apollo: {
    obrasSolicitudes: {
      query: OBRAS_SOLICITUDES,
    },
  },
  computed: {
    getLabel() {
      if (this.multiSelect === true) return 'Seleccionar obra(s)';
      return 'Seleccionar obra de solicitudes';
    },
    getEjercicio() {
      return this.formatoFechaActual().hoy.split('/')[2] || '';
    },
    getObras() {
      if (!this.obrasSolicitudes) return [];
      return this.obrasSolicitudes
        .map((obra) => ({
          id: obra.id,
          ejercicio: this.formatoFechaSeparador(`${obra.fechaInicioObra}`, { letra: false }).split('/')[2] || this.getEjercicio,
          clave: obra.clavePresupuestal,
          tipo: obra.tipoObra || { color: '#FFA' },
          meta: obra.meta || 'Sin meta',
          importe: obra.montoSolicitado,
        }));
      // this.formatoFechaSeparador(`${value}`, { letra: true }).split('/')[1] || '')
      /*
        .filter((obra) => this.obrasContratos.includes(obra.id) === false)
        .map((obra) => ({
          id: obra.id,
          ejercicio: obra.ejercicio,
          clave: obra.clave,
          tipo: obra.tipo,
          meta: obra.meta,
          programa: obra.programa,
        })); */
    },
  },
  watch: {
    obrasSeleccionadas() {
      this.search = '';
    },
  },
};
</script>

<style lang="scss">

</style>
